import React from "react";

export default function FlexBreak() {
  return <div style={{ flexBasis: "100%", height: 0 }} />;
}
